module.exports = __webpack_public_path__ + "img/BS40.95489d1d.svg";